export const setMaintenanceMode = (maintenanceMode) => {
    return{
        type: 'SET_MAINTENANCE_MODE',
        maintenanceMode
    }
}